import React from 'react';
import { Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useHGS } from '../context/HGSContext';

export default function AppShell({ children }) {
  const { user } = useHGS();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen flex bg-slate-50">
      <Sidebar />
      <main className="flex-1 min-w-0">{children}</main>
    </div>
  );
}
